// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signup-container-otemA {
  padding: 0px 16px;
}

.signup-brand_container-mzGy5 {
  justify-content: center;
  margin: 72px auto 0px;
}

.signup-card-PDa9i {
  display: flex;
  flex-direction: column;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-xl);
  padding: 20px;
  margin: 60px auto 0px;
}

.signup-cardIcon-jkxZV {
  --size: 48px;
  align-self: center;
  color: var(--color-neutral-800);
}

.signup-cardTitle_container-_8i4K {
  margin-top: 16px;
  text-align: left;
  align-self: center;
}

.signup-cardTitle_title-hfQu2 {
  font-size: var(--text-xl);
  color: var(--color-neutral-800);
}

.signup-form-dShQI {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  margin-top: 20px;
  margin-bottom: 24px;
}

.signup-sectionTitle-M7XzZ {
  grid-column: span 2;
  font-size: var(--text-base);
  font-weight: var(--font-weight-medium);
  color: var(--color-neutral-900);
  letter-spacing: var(--tracking-wide);
  margin-top: 16px;
  margin-bottom: 12px;
}

.signup-field_container-I7Hjt {
  width: 100%;
}

.signup-field_input-dVhGz,
.signup-autocomplete_content-Eu_rQ {
  height: 44px;
}

.signup-emailField_container-w5CJx {
  width: 100%;
  grid-column: span 2;
}

.signup-cityField_container-Hs0Fu {
  width: 100%;
  grid-column: span 2;
}

.signup-addressField_container-a6J1O {
  width: 100%;
  grid-column: span 2;
}

.signup-autocomplete_container-jtw2y {
  width: 100%;
}

.signup-autocomplete_popup-AAiJ8 {
  max-height: 280px;
}

.signup-termsAndPrivacyField-hFfGQ {
  width: 100%;
  grid-column: span 2;
  margin-top: 4px;
}

.signup-termsAndPrivacyLabel-WJj4b {
  display: flex;
  align-items: center;
  font-size: 15px;
  gap: 6px;
}

.signup-termsAndPrivacyCheckbox-IRJr0 {
  transform: scale(1.3);
}

.signup-invalidFields-S8bin {
  font-size: 14px;
}

.signup-button_base-mX_28 {
  width: 152px;
  margin-left: auto;
  margin-top: 8px;
}

.signup-loginContainer-uTHcy {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin: 24px auto 80px;
}

.signup-loginLabel-HR_oo {
  color: var(--color-neutral-600);
  font-size: var(--text-sm);
}

.signup-loginLink-gCRGr {
  font-size: var(--text-sm);
  font-weight: var(--font-weight-medium);
}

@media (min-width: 600px) {

  .signup-card-PDa9i {
    width: fit-content;
    padding: 28px 28px 24px;
  }
  
  .signup-form-dShQI {
    display: grid;
    grid-template-columns: repeat(2, 260px);
    column-gap: 20px;
    row-gap: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/signup/signup.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qCAAqC;EACrC,+BAA+B;EAC/B,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,sCAAsC;EACtC,+BAA+B;EAC/B,oCAAoC;EACpC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;;EAEE;IACE,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,uCAAuC;IACvC,gBAAgB;IAChB,aAAa;EACf;AACF","sourcesContent":[".container {\n  padding: 0px 16px;\n}\n\n.brand_container {\n  justify-content: center;\n  margin: 72px auto 0px;\n}\n\n.card {\n  display: flex;\n  flex-direction: column;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-xl);\n  padding: 20px;\n  margin: 60px auto 0px;\n}\n\n.cardIcon {\n  --size: 48px;\n  align-self: center;\n  color: var(--color-neutral-800);\n}\n\n.cardTitle_container {\n  margin-top: 16px;\n  text-align: left;\n  align-self: center;\n}\n\n.cardTitle_title {\n  font-size: var(--text-xl);\n  color: var(--color-neutral-800);\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  width: 100%;\n  margin-top: 20px;\n  margin-bottom: 24px;\n}\n\n.sectionTitle {\n  grid-column: span 2;\n  font-size: var(--text-base);\n  font-weight: var(--font-weight-medium);\n  color: var(--color-neutral-900);\n  letter-spacing: var(--tracking-wide);\n  margin-top: 16px;\n  margin-bottom: 12px;\n}\n\n.field_container {\n  width: 100%;\n}\n\n.field_input,\n.autocomplete_content {\n  height: 44px;\n}\n\n.emailField_container {\n  width: 100%;\n  grid-column: span 2;\n}\n\n.cityField_container {\n  width: 100%;\n  grid-column: span 2;\n}\n\n.addressField_container {\n  width: 100%;\n  grid-column: span 2;\n}\n\n.autocomplete_container {\n  width: 100%;\n}\n\n.autocomplete_popup {\n  max-height: 280px;\n}\n\n.termsAndPrivacyField {\n  width: 100%;\n  grid-column: span 2;\n  margin-top: 4px;\n}\n\n.termsAndPrivacyLabel {\n  display: flex;\n  align-items: center;\n  font-size: 15px;\n  gap: 6px;\n}\n\n.termsAndPrivacyCheckbox {\n  transform: scale(1.3);\n}\n\n.invalidFields {\n  font-size: 14px;\n}\n\n.button_base {\n  width: 152px;\n  margin-left: auto;\n  margin-top: 8px;\n}\n\n.loginContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  margin: 24px auto 80px;\n}\n\n.loginLabel {\n  color: var(--color-neutral-600);\n  font-size: var(--text-sm);\n}\n\n.loginLink {\n  font-size: var(--text-sm);\n  font-weight: var(--font-weight-medium);\n}\n\n@media (min-width: 600px) {\n\n  .card {\n    width: fit-content;\n    padding: 28px 28px 24px;\n  }\n  \n  .form {\n    display: grid;\n    grid-template-columns: repeat(2, 260px);\n    column-gap: 20px;\n    row-gap: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `signup-container-otemA`,
	"brand_container": `signup-brand_container-mzGy5`,
	"card": `signup-card-PDa9i`,
	"cardIcon": `signup-cardIcon-jkxZV`,
	"cardTitle_container": `signup-cardTitle_container-_8i4K`,
	"cardTitle_title": `signup-cardTitle_title-hfQu2`,
	"form": `signup-form-dShQI`,
	"sectionTitle": `signup-sectionTitle-M7XzZ`,
	"field_container": `signup-field_container-I7Hjt`,
	"field_input": `signup-field_input-dVhGz`,
	"autocomplete_content": `signup-autocomplete_content-Eu_rQ`,
	"emailField_container": `signup-emailField_container-w5CJx`,
	"cityField_container": `signup-cityField_container-Hs0Fu`,
	"addressField_container": `signup-addressField_container-a6J1O`,
	"autocomplete_container": `signup-autocomplete_container-jtw2y`,
	"autocomplete_popup": `signup-autocomplete_popup-AAiJ8`,
	"termsAndPrivacyField": `signup-termsAndPrivacyField-hFfGQ`,
	"termsAndPrivacyLabel": `signup-termsAndPrivacyLabel-WJj4b`,
	"termsAndPrivacyCheckbox": `signup-termsAndPrivacyCheckbox-IRJr0`,
	"invalidFields": `signup-invalidFields-S8bin`,
	"button_base": `signup-button_base-mX_28`,
	"loginContainer": `signup-loginContainer-uTHcy`,
	"loginLabel": `signup-loginLabel-HR_oo`,
	"loginLink": `signup-loginLink-gCRGr`
};
export default ___CSS_LOADER_EXPORT___;
